// @ftedn/shared — Notification types

export interface Notification {
  id: string;
  recipientId: string;
  type: NotificationType;
  title: string;
  body: string;
  data?: Record<string, string>;
  read: boolean;
  actionUrl?: string;
  channels?: NotificationChannel[];
  createdAt: string;
}

export type NotificationType =
  | 'content_submitted'
  | 'content_approved'
  | 'content_revision'
  | 'campaign_assigned'
  | 'campaign_updated'
  | 'payment_sent'
  | 'payment_received'
  | 'message_received'
  | 'shipment_update'
  | 'system_alert'
  // F6 additions
  | 'beta_accepted'
  | 'beta_rejected'
  | 'feedback_submitted'
  | 'review_submitted'
  | 'quest_completed'
  | 'level_up'
  | 'xp_earned'
  | 'post_reply'
  | 'post_liked'
  | 'idea_status'
  | 'vote_closing';

export type NotificationChannel = 'inApp' | 'sms' | 'email' | 'push';

export interface PushSubscription {
  id: string;
  userId: string;
  endpoint: string;
  keys: { p256dh: string; auth: string };
  createdAt: string;
}

// ── User notification preferences ─────────────────────

export interface UserNotificationPreferences {
  channels: {
    inApp: boolean;
    sms: boolean;
    email: boolean;
    push: boolean;
  };
  quietHours: {
    enabled: boolean;
    startHour: number;   // 0-23
    endHour: number;     // 0-23
    timezone: string;    // IANA timezone
  };
  mechanicOptOuts: string[];
}

export const DEFAULT_NOTIFICATION_PREFS: UserNotificationPreferences = {
  channels: { inApp: true, sms: true, email: true, push: true },
  quietHours: { enabled: true, startHour: 21, endHour: 8, timezone: 'America/New_York' },
  mechanicOptOuts: [],
};

// ── Frequency cap config ──────────────────────────────

export interface FrequencyCapConfig {
  channel: NotificationChannel;
  maxPerDay: number;
}

export const DEFAULT_FREQUENCY_CAPS: FrequencyCapConfig[] = [
  { channel: 'sms', maxPerDay: 3 },
  { channel: 'email', maxPerDay: 5 },
  { channel: 'push', maxPerDay: 10 },
  { channel: 'inApp', maxPerDay: 50 },
];
